import { render, staticRenderFns } from "./ingrediente-ativo.vue?vue&type=template&id=e2e84d4e&"
import script from "./ingrediente-ativo.vue?vue&type=script&lang=js&"
export * from "./ingrediente-ativo.vue?vue&type=script&lang=js&"
import style0 from "./ingrediente-ativo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports